import React from "react";
import _ from "lodash";
import PropTypes from "prop-types";

import ControlGroup from "./base/ControlGroup";
import ControlLabel from "./base/ControlLabel";
import ValueDisplay from "./base/ValueDisplay";
import HTMLEditorModal from "./editor/HTMLEditorModal";

class PropertyEditor extends React.Component {
  static defaultProps = {
    isHTML: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      modalActive: false,
    };

    this._save = this._save.bind(this);
    this._openModal = this._openModal.bind(this);
    this._closeModal = this._closeModal.bind(this);
  }

  _save(content) {
    let currentValue = _.isNil(this.props.value) ? "" : this.props.value;
    let value = this._sanitizeValue(content.text);

    const unchanged = _.isEqual(currentValue, value);
    const data = {
      name: this.props.propName,
      value: value,
      initValue: currentValue,
    };

    this.setState({ modalActive: false });
    if (this.props.onChange && !unchanged) {
      this.props.onChange(data);
    }
  }

  _sanitizeValue(value) {
    if (value != null && _.isString(value)) {
      value = value.trim();
    }

    if (_.isNaN(value)) {
      value = "";
    }

    return value;
  }

  _openModal() {
    if (!this.props.isLocked) {
      this.setState({ modalActive: true });
    }
  }

  _closeModal() {
    this.setState({ modalActive: false });
  }

  render() {
    let { label, isHTML, value, language } = this.props;

    let currentValue = _.isNil(value) ? "" : value;

    return (
      <ControlGroup className="prop-panel-group">
        <ControlLabel className="prop-editor-label" text={label} />
        <ValueDisplay
          value={currentValue}
          maxChars={150}
          onClick={this._openModal}
          title="Click To Edit"
        />
        <HTMLEditorModal
          isLocked={this.props.isLocked}
          content={currentValue}
          language={language}
          show={this.state.modalActive}
          onHide={this._closeModal}
          onSave={this._save}
          title={"Update " + label}
          validateHTML={isHTML}
        />
      </ControlGroup>
    );
  }
}

PropertyEditor.propTypes = {
  propName: PropTypes.string.isRequired,
};

export default PropertyEditor;
